import TabsList from "./components/tabs/tabs";
import InterventionCases from "./components/interventionCases/interventionCases";
import PendingProcessing from "./components/pendingProcessing/pendingProcessing";
import LayoutOfDashboard from "@layout/defaultForDashboard";
import "./empi.scss";
import moment from "moment";
import Logo from "@assets/images/wellBe.png";
import AllEMPIMaster from "./components/allEmpiMaster/allEmpiMaster";
import { useState } from "react";
import useSession from "@utils/useSession";

/************************************** */
const EMPI = () => {
  const [activeTab, setActiveTab] = useState("all_empi_master");
  const session = useSession();

  return (
    <LayoutOfDashboard>
      <div className="ui-empi">
        <div className="ui-empi__heading">
          { session?.user?.email === "pradeep.jain@tredence.com" ? null : <img src={Logo} alt="wellBe" />} EMPI Stewardship Dashboard
        </div>
        <TabsList
          items={[
            {
              label: "All EMPI Master",
              key: "all_empi_master",
              children: <AllEMPIMaster activeTab={activeTab} />,
            },
            {
              label: "Intervention Cases",
              key: "intervention_cases",
              children: <InterventionCases activeTab={activeTab} />,
            },
            {
              label: "Pending Processing",
              key: "pending_processing",
              children: <PendingProcessing activeTab={activeTab} />,
            },
            
          ]}
          // extraInfo={<div>Date as of {moment(new Date()).format("DD MMM YYYY")}</div>}
          onChange={setActiveTab}
        />
      </div>
    </LayoutOfDashboard>
  );
};

export default EMPI;
